import { ReactNode } from 'react';
import { Control, Controller, FieldValues, FieldPath } from 'react-hook-form';
import { cn } from '@/lib/utils.ts';
import InputLabel from '@/components/form/base/InputLabel.tsx';
import InputHint from '@/components/form/base/InputHint.tsx';
import InputError from '@/components/form/base/InputError.tsx';
import PrimitiveMultiSelect from '@/components/form/_primitives/PrimitiveMultiSelect.tsx';
import Option from '@/components/form/types/Option.ts';
import { SelectControlSize } from '@/components/form/_primitives/primitiveSelectStyles.ts';

const MultiSelectInput = <T extends FieldValues>({
  fieldPath,
  control,
  label,
  placeholder = 'Wybierz',
  required = false,
  hint,
  error,
  className,
  disabled = false,
  options = [],
  renderOptionLabel,
  controlSize,
}: {
  fieldPath: FieldPath<T>;
  control: Control<T>;
  label?: string;
  placeholder?: string;
  required?: boolean;
  hint?: string;
  error?: string;
  className?: string;
  disabled?: boolean;
  options?: Option[];
  /** Własny wygląd opcji i wybranej wartości — patrz `PrimitiveMultiSelect`. */
  renderOptionLabel?: (option: Option) => ReactNode;
  /** `toolbar` zrównuje pole z paskiem narzędzi tabeli — patrz panel filtrów. */
  controlSize?: SelectControlSize;
}) => {
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {label && (
        <InputLabel label={label} required={required} disabled={disabled} />
      )}
      <Controller
        control={control}
        name={fieldPath}
        render={({ field }) => (
          <PrimitiveMultiSelect
            name={fieldPath}
            id={fieldPath}
            options={options}
            placeholder={placeholder}
            disabled={disabled}
            error={error}
            value={field.value}
            onChange={(values) => field.onChange(values)}
            renderOptionLabel={renderOptionLabel}
            controlSize={controlSize}
            mobileMenuTitle={label}
          />
        )}
      />
      {hint && <InputHint hint={hint} />}
      {error && <InputError error={error} />}
    </div>
  );
};

export default MultiSelectInput;
